<div class="flex flex-col" *transloco="let t; read 'calculator_result'">
  <div *ngIf="result.avgMonthlyConsumptionDuringLoan === 0">
    <psc-section-title
      [title]="t('invalid_credit.title')"
      alignment="left"
      size="small"
      [color]="colorConfig.textColor"
      [lineColor]="colorConfig.bgColor"
      [lineWidthPercentage]="100"
      [lineThickness]="2"></psc-section-title>
    <div class="flex text-xl {{colorConfig.textColor}} py-4 justify-center">
      {{ t('invalid_credit.message', { minCredit: 5000, currency: 'EUR' }) }}
    </div>
  </div>
  <psc-yearly-consumption-projection-chart
    [colorConfig]="colorConfig"
    *ngIf="result.avgMonthlyConsumptionDuringLoan !== 0"
    [solarCalculatorResult]="result"></psc-yearly-consumption-projection-chart>
  <psc-user-investment
    [colorConfig]="colorConfig"
    [smallTitle]="true"
    [solarCalculatorResult]="result"></psc-user-investment>
  <psc-solar-assessment
    [colorConfig]="colorConfig"
    [smallTitle]="true"
    [solarCalculatorResult]="result"></psc-solar-assessment>
</div>
